import React, { useEffect, useState, useContext } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { GlobalContext } from '../../Contexts/GlobalContext';
import PushSettings__Default from './PushSettings__Default';
import PushSettings__Denied from './PushSettings__Denied';
import PushSettings__Granted from './PushSettings_Granted';
import useOneSignal from '../../CustomHooks/useOneSignal';

export default function PushSettings(props) {
    const globalContext = useContext(GlobalContext);
    const classes = useStyles();
    const [permission, setPermission] = useState('');
    const nullValue = useOneSignal();

    useEffect(
        () => {
            setPermission(Notification.permission);
        

        }, []
    )

    useEffect(
        () => {

            globalContext.dispatchMethod(
                {
                    type: 'SET_MENU_LOCATION',
                    value: {
                        a: 8,
                        b: 124,
                    },
                }
            )
        }, []
    )


    return (
        <div className={classes.root}>

            {
                permission == "default" ?
                    <PushSettings__Default></PushSettings__Default>
                    : null
            }
            {
                permission == "denied" ?
                    <PushSettings__Denied></PushSettings__Denied>
                    : null
            }
            {
                permission == "granted" ?
                    <PushSettings__Granted></PushSettings__Granted>
                    : null
            }
        </div>
    )
}

const useStyles = makeStyles({
    root: {
    }
});